<template>
  <button
    v-if="contentSource"
    class="content-source-preview-component"
    @click="openContentSource"
  >
    <img
      v-if="contentSourceAttachment"
      class="preview-image"
      :src="contentSourceAttachment.smallThumbnail"
      alt=""
      role="presentation"
    />
    <label-text :size="'md'">
      {{ contentSource.name }}
    </label-text>
  </button>
</template>

<script>
import LabelText from '@/components/ui/label-text.vue';

export default {
  components: {
    LabelText,
  },
  props: {
    contentSource: {
      type: Object,
    },
  },
  computed: {
    contentSourceAttachment() {
        return this.$store.getters['attachments/get'][this.contentSource.previewAttachmentId];
    },
  },
  created() {
    if (this.contentSource?.previewAttachmentId) {
      this.$store.dispatch('attachments/fetch', { ids: [this.contentSource.previewAttachmentId] });
    }
  },
  methods: {
    openContentSource() {
      this.$sheets.show('content-source', this.contentSource);
    },
  },
};
</script>

<style lang="scss" scoped>
.content-source-preview-component {
  align-items: center;
  background: transparent;
  display: flex;
  margin: rem-calc(32) 0;
  padding: 0;
  text-align: left;
  width: 100%;

  .preview-image {
    border-radius: 100%;
    height: rem-calc(32);
    margin-right: rem-calc(8);
    object-fit: cover;
    object-position: center;
    width: rem-calc(32);
  }
}
</style>
